export default __webpack_public_path__ + "static/154-e065a546628bdb3dd53daa79fc0865ea.jpg";